import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface InvestorSlide0Props {
  isDark?: boolean;
}
export function InvestorSlide0({
  isDark = false
}: InvestorSlide0Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const lightModeLogo = 'https://cdn.magicpatterns.com/uploads/gsWfp7Yqa2Z6SBgP3SbdyL/HELIONA_transparent.png';
  const darkModeLogo = 'https://cdn.magicpatterns.com/uploads/siQDa69uZkA61S2PiBLFML/Heliona_Logo_-_Dark.png';
  return <div className="h-full flex items-center justify-center max-w-7xl mx-auto px-6 sm:px-12 py-16 sm:py-24" data-id="element-126">
      <motion.div className="flex flex-col items-center text-center max-w-4xl" variants={containerVariants} initial="hidden" animate="visible" data-id="element-127">
        {/* Logo */}
        <motion.div variants={itemVariants} className="mb-10 sm:mb-14" data-id="element-128">
          <img src={isDark ? darkModeLogo : lightModeLogo} alt="Heliona Logo" className="h-16 sm:h-24 mx-auto" data-id="element-129" />
        </motion.div>

        {/* Tagline */}
        <motion.div variants={itemVariants} className={`mb-8 sm:mb-10 inline-flex px-6 sm:px-8 py-3 rounded-full backdrop-blur-sm shadow-sm ${isDark ? 'bg-heliona-mint/10 border border-heliona-mint/30' : 'bg-heliona-mint/10 border border-heliona-mint/30'}`} data-id="element-130">
          <span className={`font-semibold text-sm sm:text-base tracking-wider uppercase ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-131">
            The Leadership Wellness Platform
          </span>
        </motion.div>

        {/* Main Title */}
        <motion.h1 variants={itemVariants} className={`text-5xl sm:text-7xl font-bold mb-6 sm:mb-8 leading-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-132">
          Heliona
        </motion.h1>

        <motion.p variants={itemVariants} className={`text-xl sm:text-3xl font-medium mb-16 sm:mb-24 ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-133">
          Investor Presentation
        </motion.p>

        {/* Decorative Element */}
        <motion.div variants={itemVariants} className={`text-sm sm:text-base animate-pulse ${isDark ? 'text-white/60' : 'text-heliona-text-gray/60'}`} data-id="element-134">
          Press → to begin
        </motion.div>
      </motion.div>
    </div>;
}